"use client";
import Image from "next/image";

const AwardCard = ({ image, title }) => {
    return (
        <div className="relative overflow-hidden group transition-transform duration-500 hover:-translate-y-1 hover:shadow-xl">
            <div className="relative h-64 w-full">
                <Image
                    src={image}
                    alt={title}
                    fill
                    sizes="(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw"
                    className="object-cover transition-transform duration-500 group-hover:scale-105"
                />
            </div>

            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />

            <div className="absolute inset-x-0 bottom-0 p-4">
                <h3 className="text-white text-lg font-semibold leading-tight">
                    {title}
                </h3>
            </div>
        </div>
    );
};

export default AwardCard;
